import { render, staticRenderFns } from "./Door_Forced_open_Alarm_out.vue?vue&type=template&id=54a9f3e0"
import script from "./Door_Forced_open_Alarm_out.vue?vue&type=script&lang=js"
export * from "./Door_Forced_open_Alarm_out.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports